import type { StatusTone } from '@trips/shared/flight-status';
import s from './StatusPill.module.css';

/** A flight's status in its colour: green on time, amber late, red very late or cancelled. */
export function StatusPill({
  label,
  tone,
  className,
}: {
  label: string;
  tone: StatusTone;
  className?: string;
}) {
  return (
    <span className={`${s.pill} ${className ?? ''}`} data-tone={tone}>
      {label}
    </span>
  );
}
